import React from "react";

const NotFound = () => (
  <div>
    <h2>NOTFOUND!!!!!1</h2>
  </div>
);

export default NotFound;